module.exports = __webpack_public_path__ + "img/a39dd6b.jpg";